export class RelatedKnowledgebaseResult {
    relatedknowledgebaseId: number;
    relatedknowledgebaseTitle: string;
}
